import { APPEND_LOADING, REMOVE_LOADING } from './http_requests_on_load.types';

export const httpRequestsOnLoadActions = {
  appendLoading: (loadingType, params) => ({
    type: APPEND_LOADING,
    payload: { type: loadingType, params },
  }),
  removeLoading: (loadingType) => ({
    type: REMOVE_LOADING,
    payload: { type: loadingType },
  }),
};
